module.exports = __webpack_public_path__ + "img/gongxifacai_01_068be0fb7.png";